import { motion, useAnimation } from 'motion/react';
import React, { PropsWithChildren, useEffect } from 'react';

export const SafeMotionTr = React.forwardRef<
  HTMLTableRowElement,
  PropsWithChildren<any>
>(({ children, ...props }, ref) => {
  const controls = useAnimation();

  useEffect(() => {
    return () => {
      controls.stop();
    };
  }, [controls]);

  return (
    <motion.tr ref={ref} animate={controls} {...props}>
      {children}
    </motion.tr>
  );
});
